import styled from 'styled-components'

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 14px;
    margin: 0;
    margin-top: 1.5rem;
  }
  @media only screen and (min-width: 1100px) {
    h2 {
      margin-bottom: 0.5rem;
    }
  }
  @media only screen and (min-width: 1400px) {
    h2 {
      margin-bottom: -3%;
    }
  }
`

export const Modal = styled.div`
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  width: 100vw;
  height: 90vh;
  min-width: 300px;
  border-radius: 3px;
  border: solid 0.1px ${({ theme }) => `rgb(${theme.component.accent})`};

  hr {
    display: none;
    opacity: 0.3;
  }

  @media only screen and (min-width: 1090px) {
    width: 60%;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    hr {
      display: flex;
      width: 100%;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;

  h1 {
    margin: 0;
    font-size: 22px;
    font-weight: bolder;
  }
  h2 {
    margin: 12px 0 0 0;
    font-weight: 400;
  }
  button {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    font-size: 19px;
  }
`

export const CardsAnnotations = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 13px;
  max-height: 30rem;
  margin-top: 0.5rem;

  overflow: auto;
  ::-webkit-scrollbar {
    width: 2px;
  }

  @media only screen and (min-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    max-height: 40rem;
    margin-bottom: 1rem;
    padding: 0 1rem;
  }
`

export const CardMark = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-width: 16rem;
  max-width: 80rem;
  border-radius: 5px;

  &.highlight-1 {
    background: #f2f200 !important;
  }

  &.highlight-2 {
    background: #22f200 !important;
  }

  &.highlight-3 {
    background: #00f2f2 !important;
  }

  &.highlight-4 {
    background: #f201f2 !important;
  }

  div {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }

  p {
    margin: 5px;
    min-width: 12rem;
    max-width: 60rem;
    max-height: 3.5rem;
    font-size: 14px;
    font-weight: 400;
    word-wrap: break-word;
    margin-bottom: 0;
    color: #000;
  }
  button {
    display: flex;
    text-align: center;
    color: #4a4a4a;
    border: none;
    background: none;
    font-weight: 700;
  }
  .seeNote {
    float: inline-start;
  }
`
export const CardNote = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-width: 16rem;
  max-width: 80rem;
  border-radius: 5px;

  &.highlight-1 {
    background: #f2f200 !important;
  }

  &.highlight-2 {
    background: #22f200 !important;
  }

  &.highlight-3 {
    background: #00f2f2 !important;
  }

  &.highlight-4 {
    background: #f201f2 !important;
  }

  div {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }

  p {
    margin: 5px;
    min-width: 12rem;
    max-width: 60rem;
    max-height: 4rem;
    font-size: 14px;
    font-weight: 400;
    word-wrap: break-word;
    margin-bottom: 0;
    color: #000;
  }
  button {
    display: flex;
    text-align: center;
    color: #4a4a4a;
    border: none;
    background: none;
    font-weight: 700;
  }
  .seeNote {
    float: inline-start;
  }
`
export const NoteDeleteEdit = styled.span`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  padding: 10px;
  p {
    overflow-y: auto;
    ::-webkit-scrollbar {
      width: 2px;
    }
  }
  button {
    align-items: flex-start;
    float: inline-end;
    padding-left: 0.1rem;
    color: #4a4a4a;
  }
`

export const ChangeColor = styled.span`
  display: flex;
  justify-content: space-evenly;
  background: #262626;
  z-index: 10000;
  border-radius: 5px;
  height: 35px;

  &::before {
    content: '';
    border-style: solid;
    border-color: #262626 transparent;
    border-width: 0 4px 4px 4px;
    bottom: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  button {
    color: #fff;
    background: none;
    border: none;

    display: flex;
    align-items: center;

    font-size: 14px;
    font-weight: 600;

    svg {
      margin-right: 0.3rem;
    }

    z-index: 10000;
    .highlight-1,
    .highlight-2,
    .highlight-3,
    .highlight-4 {
      cursor: pointer;
      -webkit-user-select: none; /* Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE10+/Edge */
      user-select: none; /* Standard */
      width: 27px;
      height: 27px;
      border-radius: 27px;
    }
    .highlight-1 {
      background: #f2f200 !important;
    }

    .highlight-2 {
      background: #22f200 !important;
    }

    .highlight-3 {
      background: #00f2f2 !important;
    }

    .highlight-4 {
      background: #f201f2 !important;
    }
  }
`

export const NoteAndDelete = styled.span`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 10px;
  p {
    overflow-y: auto;
    ::-webkit-scrollbar {
      width: 2px;
    }
  }
  button {
    align-items: flex-start;
    float: inline-end;
    padding-left: 0.1rem;
    color: #4a4a4a;
  }
`

export const ButtonsSendCancel = styled.div`
  display: flex;
  justify-content: end;
  border: none;
  padding: 1rem;
  button {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    border: solid 0.1px rgba(186, 186, 186, 1);
    background-color: transparent;
  }
  .back-button {
    border-radius: 5px;
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.background.high})`};
    border: none;
    padding: 10px 20px 10px 20px;
    font-weight: 600;
  }
  @media only screen and (max-width: 800px) {
    display: none;
  }
`
